import { transport } from '../../transport';
import {
  APPLICATION_PATH,
  BASE_PATH,
  PROJECT_PATH,
  SECURITY_GROUPS_PATH,
} from '../config';

function updateSecurityGroups(
  securityGroups,
  { organizationId, projectId, applicationId },
) {
  const path = `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${projectId}${APPLICATION_PATH}/${applicationId}${SECURITY_GROUPS_PATH}`;
  return transport.put(path, { securityGroups });
}

export const securityGroupsService = {
  updateSecurityGroups,
};
